import { Seat } from "./seat";
import { Travel } from "./travel";
import { Person } from "./person";
import { SeatBooking } from "./seatbooking";
import { SessionService } from "../session.service";
import { Segment } from "./segment";
import { PassengerType } from "./passengertype";
import { FromJSONable } from "./FromJSONable";
import { Wagon } from "./wagon";
import { Route2 } from "./route2";
import { Cost } from "./cost";
import {
  DateDisabledDatePicker,
  DateDisabledByStation,
} from "./dateDisabledDatePicker";
//0 = inactive 1= editing 2= booked 3= paid 4= cancelled
export class RouteBooking implements FromJSONable {
  public static inactive: number = 0;
  public static editing: number = 1;
  public static booked: number = 2;
  public static paid: number = 3;
  public static cancel: number = 4;
  public id: number;
  public status: number = 1;
  public seats: SeatBooking[] = [];
  public persons: Person[] = [];
  public etickets_email: string = "";
  public etickets_email2: string = "";
  public etickets_phone: string = "";
  public etickets_emergency_contact: string = "";
  public etickets_contact_firstName: string = "";
  public etickets_contact_lastName: string = "";
  public observaciones: string = "";
  public classID: number = 0;
  public routeID: number = 0;
  public travels: Travel[] = [];
  public pp: boolean = false;
  public round: boolean = false;
  public dateDisabledDatePicker: DateDisabledDatePicker[] = [];
  public booking_code: string = "";
  public booking_totalamount: string = "";
  public booking_tax: string = "";
  public escala: any[] = new Array();
  public booking_discount: string = "";
  public formaPago: any = {};
  parseJSONObject(object: Object) {
    if (!object) {
      return;
    }
    Object.assign(this, object);
    this.seats = [];
    var x: Object[] = object["seats"];

    if (x) {
      for (var i = 0; i < x.length; i++) {
        let y: SeatBooking = new SeatBooking(
          new Seat(),
          new Wagon(),
          new Travel(),
          new Route2(),
          new PassengerType(),
          new Cost(),
          0,
          0
        );
        y.parseJSONObject(x[i]);
        this.seats.push(y);
      }
    }
    this.persons = [];
    var x: Object[] = object["persons"];
    if (x) {
      for (var i = 0; i < x.length; i++) {
        let y: Person = new Person();
        y.parseJSONObject(x[i]);
        y.id = i;
        this.persons.push(y);
      }
    }
    this.travels = [];
    var x: Object[] = object["travels"];
    if (x) {
      for (var i = 0; i < x.length; i++) {
        let y: Travel = new Travel();
        y.parseJSONObject(x[i]);
        this.travels.push(y);
      }
    }
    this.dateDisabledDatePicker;
    var x: Object[] = object["dateDisabledDatePicker"];
    /* if(x){
            for(var i=0;i<x.length;i++){
                let y:DateDisabledDatePicker = new DateDisabledDatePicker();y.parseJSONObject(x[i]);
                this.dateDisabledDatePicker.push(y);
            }
        }*/
    //console.log(x);
  }
  public setupFromSession(session: SessionService) {
    //setup travels
    for (var i = 0; i < session.segments.length; i++) {
      let s: Segment = session.segments[i];
      this.travels.push(s.selected_travel);
    }

    this.round = session.query.round;
    this.routeID = session.route.id;
    this.classID = session.query.class;
    //setup persons
    var flag = 0;
    var arregloAdulto = [];
    for (var i = 0; i < session.route.passenger_types.length; i++) {
      let pt: PassengerType = session.route.passenger_types[i];
      let ptq: number = session.query.passengers[pt.id];

      for (var j = 0; j < ptq; j++) {
        var p: Person = new Person();
        p.type = pt;
        p.id_passenger_type = pt.id;
        p.id = flag;
        this.persons.push(p);

        if (p.id_passenger_type < 3) {
          arregloAdulto.push(p.id);
          p.parent_id = -1;
        }
        if (p.id_passenger_type == 3) {
          p.parent_id = arregloAdulto.shift();
          session.rb.persons[j].child = true;
        }
        flag = flag + 1;
      }
    }
  }
}
